import './App.css';
import React, { createContext, useContext } from 'react';
import { AccountInfo } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MainContent from './MainContent';

const queryClient = new QueryClient();

// 1. Create context
export const AccountContext = createContext<{
  activeAccount: AccountInfo | null;
  setActiveAccount: (acc: AccountInfo | null) => void;
}>({
  activeAccount: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setActiveAccount: () => {},
});

// 2. Custom hook for easy access
export const useAccount = () => useContext(AccountContext);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <MainContent />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
